import HorizontalList from '../classes/HorizontalList';
import TrackBar from '../classes/TrackBar';
import { DOM } from '../shared/helpers/Document';

(function() {
	document.addEventListener('pageLoad', () => {
		const posts = Array.from(DOM.qsa('.cards-list-nowrap'));
		posts.forEach(postsItems => {
			const items = postsItems.querySelector('.touchable-object');
			const effectEl = items.querySelector('.cards-list-items');
			const horizontalList = new HorizontalList(postsItems, items, effectEl, '.cards-list-item');
			
			const track = postsItems.querySelector('.ui-scroll-state');
			if( track ) {
				const trackBar = new TrackBar(track, postsItems);
				horizontalList.attachTrack(trackBar);
			}
			
			if( document.documentElement.classList.contains('has-pointer') ) {
				horizontalList.withNearbyFeedback();
			}
		});
	});
})();